<template>
    <FormKit
        ref="searchFieldInput"
        v-model="searchValue"
        type="search"
        :placeholder="$t('shopPage.search.placeholder')"
        :classes="{
            inner: {
                'ring-1': false,
                'bg-white': true,
                'border-none': true,
                'py-4': false,
                'px-3': false,
                'h-[2.25rem]': true,
                'rounded-lg': false,
                'rounded-full': true,
                'focus-within:ring-blue-500': false,
                'focus-within:ring-2': false,
                '[&>label:first-child]:focus-within:text-blue-500': false,
                'rounded': false,
                'ring-gray-400': true,
                'ring-0': !searchFocus,
                'ring-1 ring-current': searchFocus
            },
            input: {
                'p-4': searchFocus,
                'w-1': true,
                'w-full': searchFocus,
                'border-none': !searchFocus
            },
            outer: `${!searchFocus ? 'right-[calc(100%-2.25rem)]' : 'right-0'} absolute top-1/2 -translate-y-1/2 left-0 z-50 transition-all`
        }"
        @focusout="onFocusOut">
        <template #prefixIcon>
            <Icon
                :icon="IconSearch"
                class="cursor-pointer rounded-full p-2.5 transition-opacity hover:opacity-80"
                :class="!searchFocus ? 'bg-primary pr-2.5 text-white' : 'bg-transparent pr-0'"
                :auto-align="false"
                @click="setFocus" />
        </template>
    </FormKit>
</template>

<script setup lang="ts">
    import IconSearch from '@/assets/icons/search.svg'
    import Icon from '~/components/Icon.vue'
    import { shop } from '~/store/shop'
    const { $event } = useNuxtApp()
    const searchFieldInput = ref()
    const currentScroll = ref(0)
    const searchFocus = ref(false)
    const searchValue = computed({
        get: () => shop().searchValue,
        set: val => {
            let scrollTarget = 0
            if (val === '') {
                scrollTarget = currentScroll.value
            }
            setTimeout(() => {
                window.scrollTo({
                    top: scrollTarget,
                    left: 0,
                    behavior: 'instant'
                })
            }, 1)
            shop().setSearchValue(val)
        }
    })
    function setFocus () {
        searchFieldInput.value.$el.querySelectorAll('input')[0].focus()
        searchFocus.value = !searchFocus.value
        currentScroll.value = window.scrollY || document.documentElement.scrollTop
        // @vue-expect-error useUnknownInCatchVariables - TODO: solve TS $listen is of type unknown
        $event('search-focus-in')
    }
    function onFocusOut () {
        if (!searchValue.value) {
            searchFocus.value = false
            // @vue-expect-error useUnknownInCatchVariables - TODO: solve TS $listen is of type unknown
            $event('search-focus-out')
        }
    }
</script>
